<div class="refund-options-header">
  <h4>
    <ng-container i18n>Refund Options</ng-container>
    <span *ngIf="isOptional === false"> <ng-container i18n>(required)</ng-container></span>
  </h4>
  <button mat-icon-button (click)="onAdd()" aria-label="Add refund option" i18n-aria-label>
    <mat-icon>add</mat-icon>
  </button>
</div>

<ng-container [formGroup]="form" *ngIf="!isEmpty; else isEmptyDefaultTemplate">
  <ng-container formArrayName="options"
                *ngFor="let item of formOptionsArray.controls; let i = index; let isLast = last">
    <ng-container [formGroupName]="i">
      <fieldset class="refund-options-item">
        <mat-checkbox formControlName="default" (click)="onToggleDefault(i)"></mat-checkbox>
        <mat-form-field appearance="outline">
            <mat-label i18n>Title</mat-label>
            <input matInput formControlName="title" type="text" required>
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label i18n>Type</mat-label>
            <mat-select formControlName="type" required>
                <mat-option [value]="'adjustment'" i18n>Percentage</mat-option>
                <mat-option [value]="'fixed'" i18n>Fixed amount</mat-option>
                <mat-option [value]="'custom'" i18n>Custom amount</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label i18n>Amount</mat-label>
            <input matInput formControlName="adjustment" type="number" required>
        </mat-form-field>
        <button mat-icon-button (click)="onDelete(i)" aria-label="Delete option" i18n-aria-label>
          <mat-icon>delete</mat-icon>
        </button>
      </fieldset> <!-- //item -->

      <fui-value-list-control formControlName="metadata"
                              [title]="optionMetadataTitle(i)">
      </fui-value-list-control>

      <div *ngIf="!isLast" class="mt-5"><mat-divider></mat-divider></div>

    </ng-container> <!-- //item-group -->
  </ng-container> <!-- //form-array -->
</ng-container> <!-- //form-group -->

<ng-template #isEmptyDefaultTemplate>
  <div class="text-muted" i18n>No refund options have been defined for this action.</div>
</ng-template>
